// extracted by mini-css-extract-plugin
export var checkbox = "_82-0";
export var circle = "_82-3";
export var horizontalContainer = "_82-7";
export var sm = "_82-5";
export var switch0 = "_82-2";
export var switchDisabled = "_82-8";
export var switchEnabled = "_82-1";
export var textSwitchContainer = "_82-9";
export var textSwitchOption = "_82-a";
export var textSwitchOptionSelected = "_82-b";
export var verticalContainer = "_82-6";
export var xs = "_82-4";